export const VehicleTableConfig: NeoTableConfig = {
  title: "Vehicles",
  table: {
    columns: [
      {
        uid: "vehicleName",
        name: "Vehicle Name"
      },
      {
        uid: "model",
        name: "Model"
      },
      {
        uid: "category",
        name: "Category"
      },
      {
        uid: "shortName",
        name: "Short Name"
      },
      {
        uid: "fuelType",
        name: "Fuel Type"
      },
      {
        uid: "seatingCapacity",
        name: "Seating Capacity"
      },
      {uid: "mappedUserCount", name: "User count"},
      {
        uid: "registrationNumber",
        name: "Registration Number"
      },
      {
        uid: "updatedDt",
        name: "Updated Date"
      },
      {name: "Actions", uid: "actions", type: "actions"}
    ],

    activeColumns: [
      "registrationNumber",
      "shortName",
      "vehicleName",
      "seatingCapacity",
      "fuelType",
      "category",
      "model",
      "mappedUserCount",
      "updatedDt",
      "actions"
    ],
    style: {
      height: "h-full"
    },
    meta: {
      id: 2,
      title: "Vehicles",
      description: "Total Vehicles",
      hasSearch: true,
      hasUpload: false,
      hasDownload: true,
      hasAdd: false,
      hasActions: true,
      hasCheckbox: false,
      hasFilter: false,
      hasFooter: true,
      hasHeader: true,
      hasPagination: true,
      hasCreate: false
    },
    url: {
      page: {
        view: "vehicles/${navId}/view/vehicle-details",
        add: "vehicles/new/create/vehicle",
        edit: "vehicles/${navId}/edit/vehicle"
      },
      api: {
        upload: "/api/vehicles/upload",
        download: "/api/vehicles/download",
        delete: "/api/vehicles/delete",
        get: "/api/vehicles/list"
      }
    },
    actions: [
      {
        key: "view",
        label: "View",
        type: "navigate",
        isVisible: true
      },
      // we can enable for phase 2
      {
        key: "delete",
        label: "Delete",
        type: "modal",
        isVisible: false
      },
      {
        key: "deactivate",
        label: "Deactivate",
        type: "modal",
        isVisible: false
      }
    ]
  }
};
